/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

import { ContentContext } from "context/contentContext";

/**
 * import components
 */

import { Svg__star } from "components/svg/svg";
/**
 * styled components
 */

const Container = styled.div`
  ${t.mixins.flex({ justify: "flex-start" })}
  cursor: pointer;

  ${t.mixins.flex({ align: "flex-start", direction: "column" })}
`;
const Stars = styled.div`
  display: inline-block;
  margin-right: ${t.grid.space1};
`;
const Title = styled.span`
  ${t.mixins.rem(13, 12)}
  font-family: ${t.font.primary};
`;
const Opinion = styled.span`
  text-decoration: underline;
`;
const Ghost = styled.div`
  height: 30px;
`;

/**
 * rating component is..
 */

const Content__rating = ({ rating, opinion, onClick, centered }) => {
  const { c } = useContext(ContentContext);
  if (opinion === 0) return <Ghost />;
  return (
    <Container
      onClick={() => {
        onClick();
      }}
      centered={centered}
    >
      <Stars>
        {Array(Math.floor(rating))
          .fill(1)
          .map((star, index) => (
            <Svg__star key={index} filled={index + 1 <= rating} style={{ margin: "0 1px" }} />
          ))}
        {Math.round(rating) !== Math.floor(rating) && (
          <Svg__star key={"star_half"} style={{ margin: "0 1px" }} half />
        )}
        {Array(5 - Math.round(rating))
          .fill(1)
          .map((star, index) => (
            <Svg__star key={index} style={{ margin: "0 1px" }} />
          ))}
      </Stars>
      <Title>
        {rating}/5 (
        <Opinion>
          {opinion} {c("home.products.opinion")}
        </Opinion>
        )
      </Title>
    </Container>
  );
};

export default Content__rating;

Content__rating.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Content__rating.defaultProps = {
  style: {},
};

/*
    import Content__rating from 'components/content/rating/content__rating'
    <Content__rating />
  */
